import { Link } from 'react-router-dom';
import { comics } from '@/mocks/data';

export default function FeaturedComics() {
  const featured = comics.slice(0, 5);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              热门<span className="text-accent-500">韩漫</span>推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">精选高分韩国漫画，不容错过</p>
          </div>
          <Link
            to="/category/fantasy"
            className="whitespace-nowrap cursor-pointer bg-foreground-900 text-background-50 px-4 py-1.5 rounded-full text-xs font-medium hover:bg-foreground-800 transition-colors"
          >
            查看全部
          </Link>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide" style={{ scrollbarWidth: 'none' }}>
          {featured.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex-shrink-0 w-[200px] md:w-[240px] group"
              style={idx === featured.length - 1 ? {} : {}}
            >
              <div className="bg-background-50 rounded-lg overflow-hidden">
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    title={`${comic.title} - 韩漫大全`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  />
                </div>
              </div>
              <div className="flex items-start justify-between mt-3 px-1">
                <div>
                  <p className="text-xs text-foreground-400 mb-0.5">{comic.categoryName}</p>
                  <p className="text-sm font-medium text-foreground-900 group-hover:text-accent-500 transition-colors line-clamp-1">
                    {comic.title}
                  </p>
                </div>
                <span className="text-xl font-bold text-foreground-900 whitespace-nowrap ml-2">{comic.rating}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}